import { render, staticRenderFns } from "./BoletimMedicaoAbas.vue?vue&type=template&id=cbf9336a&"
import script from "./BoletimMedicaoAbas.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoAbas.vue?vue&type=script&lang=js&"
import style0 from "./BoletimMedicaoAbas.vue?vue&type=style&index=0&id=cbf9336a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports